import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const searchAssociatedEmployersByTitle = (page, count, title) => {
  return getItem('token').then(token => {
    if (!page || page < 0) {
      page = 0
    }
    let url = '/institution/searchAssociatedEmployers?page=' + page
    if (count >= 0) {
      url = url + '&count=' + count
    }
    if (title) {
      url = url + '&title=' + encodeURIComponent(title)
    }
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getEmployerOrgInfo = (employerId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('institution/' + employerId + '/employerinfo')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getSubOrganizationsByParent = (parentId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('suborganization/' + parentId + '/all')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/employer/api.js